// extracted by mini-css-extract-plugin
export default {"modal":"f0DY01eHG9sPkMhQ_1Nj","leftSideContentWrapper":"rlJ2Tc7JW1LjbtN3dWQ8","mainWrapper":"RyT2Xxvs5PRQxAhE40WM","mainContentWrapper":"apt3AxLCoWEBa3cZdmMX"};